import { Routes, Route } from "react-router-dom";

import DashboardLayout from "../layouts/DashboardLayout";
import DashboardLayoutDemo from "../layouts/DashboardLayoutDemo";
// import BlogLayout from "../layouts/BlogLayout";

import ProtectedRoute from "./ProtectedRoute";

import Overview from "../pages/production/Overview";
import Reviews from "../pages/production/Reviews";
import Responses from "../pages/production/Responses";
import Notifications from "../pages/production/Notifications";
import Settings from "../pages/production/Settings";
import Billing from "../pages/production/Billing";

import OverviewDemo from "../pages/demo/OverviewDemo";
import ReviewsDemo from "../pages/demo/ReviewsDemo";
import ResponsesDemo from "../pages/demo/ResponsesDemo";
import NotificationsDemo from "../pages/demo/NotificationsDemo";
import SettingsDemo from "../pages/demo/Settings";
import BillingDemo from "../pages/demo/BillingDemo";

import Terms from "../pages/legal/Terms";
import Privacy from "../pages/legal/Privacy";
import Help from "../pages/help/Help";
import GettingStarted from "../pages/help/GettingStarted";
import ReviewResponses from "../pages/help/ReviewResponses";
import GoogleConnection from "../pages/help/GoogleConnection";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import ForgotPassword from "../pages/auth/ForgotPassword";
import LandingPage from "../pages/LandingPage";
import BusinessOnboarding from "../pages/onboarding/BusinessOnboarding";
import EmailPreview from "../pages/demo/EmailPreview";

// import PositiveReviewExamples from "../pages/blog/PositiveReviewExamples";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/email-preview" element={<EmailPreview />} />

      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* Demo */}
      <Route element={<DashboardLayoutDemo />}>
        <Route path="/overview-demo" element={<OverviewDemo />} />
        <Route path="/reviews-demo" element={<ReviewsDemo />} />
        <Route path="/responses-demo" element={<ResponsesDemo />} />
        <Route path="/notifications-demo" element={<NotificationsDemo />} />
        <Route path="/settings-demo" element={<SettingsDemo />} />
        <Route path="/billing-demo" element={<BillingDemo />} />
        <Route path="/help-demo" element={<Help />} />
        <Route path="/help/getting-started-demo" element={<GettingStarted />} />
        <Route
          path="/help/review-responses-demo"
          element={<ReviewResponses />}
        />
        <Route
          path="/help/google-connection-demo"
          element={<GoogleConnection />}
        />
      </Route>

      {/* Production */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/overview" element={<Overview />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/responses" element={<Responses />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/help" element={<Help />} />
          <Route path="/help/getting-started" element={<GettingStarted />} />
          <Route path="/help/review-responses" element={<ReviewResponses />} />
          <Route
            path="/help/google-connection"
            element={<GoogleConnection />}
          />
        </Route>
        <Route path="/onboarding/business" element={<BusinessOnboarding />} />
      </Route>

      <Route path="/legal/terms" element={<Terms />} />
      <Route path="/legal/privacy" element={<Privacy />} />

      {/* <Route element={<BlogLayout />}>
        <Route
          path="/blog/positive-review-response-examples"
          element={<PositiveReviewExamples />}
        />
      </Route> */}
    </Routes>
  );
}
